export default __webpack_public_path__ + "37af63c7a0d5b48483af0261c3fe8faf.png";